
export let CONFIG: any = {
   
   //------------------------//   Production   // ----------------------------------------------- 

    API_ENDPOINT: 'https://raisina-orfonline.com:3000/',

   //------------------------//   localHost   // ----------------------------------------------- 

   //API_ENDPOINT: 'http://localhost:3001/',

   //----------------------//      dev        //-----------------------------------------

   // API_ENDPOINT: 'https://devmisafeadmin.in:3004/',


};